import React from "react";

export default function PortfolioPackageEditor({
    draft,
    onChange,
    onSave,
    onReset,
    onDelete,
    onDuplicate,
    saving,
    hasChanges,
    supabaseEnabled,
}) {
    if (!draft) {
        return (
            <aside className="package-editor">
                <div className="package-editor__empty">Soldaki listeden bir paket seçin veya yeni bir tane ekleyin.</div>
            </aside>
        );
    }

    const handleFieldChange = (field, value) => {
        onChange({ ...draft, [field]: value });
    };

    const handleMetaChange = (index, value) => {
        const next = [...(draft.meta ?? [])];
        next[index] = value;
        onChange({ ...draft, meta: next });
    };

    const addMeta = () => {
        onChange({ ...draft, meta: [...(draft.meta ?? []), ""] });
    };

    const removeMeta = (index) => {
        const next = (draft.meta ?? []).filter((_, idx) => idx !== index);
        onChange({ ...draft, meta: next });
    };

    const handleBodyChange = (index, value) => {
        const next = [...(draft.body ?? [])];
        next[index] = value;
        onChange({ ...draft, body: next });
    };

    const addBody = () => {
        onChange({ ...draft, body: [...(draft.body ?? []), ""] });
    };

    const removeBody = (index) => {
        const next = (draft.body ?? []).filter((_, idx) => idx !== index);
        onChange({ ...draft, body: next });
    };

    return (
        <aside className="package-editor" aria-label="Portfolyo paket düzenleyici">
            <header className="package-editor__header">
                <div>
                    <span className="package-editor__badge">{draft.cardTitle || "Paket"}</span>
                    <h3 className="package-editor__title">{draft.title || "Yeni paket"}</h3>
                </div>
                <div className="package-editor__status">
                    <label className="package-editor__checkbox">
                        <input
                            type="checkbox"
                            checked={draft.published !== false}
                            onChange={() => handleFieldChange("published", !draft.published)}
                        />
                        Yayında olsun
                    </label>
                    {!supabaseEnabled && (
                        <p className="package-editor__hint">Supabase olmadan yayın durumu sadece bu oturumda tutulur.</p>
                    )}
                </div>
            </header>

            <section className="package-editor__preview">
                <div className="package-preview-card">
                    <span className="package-preview-card__badge">{draft.cardTitle || "BAŞLIK"}</span>
                    <h4 className="package-preview-card__title">{draft.title || "Portfolyo Paketi"}</h4>
                    <p className="package-preview-card__summary">{draft.cardSummary || "Hero kartında görünecek kısa açıklama"}</p>
                </div>
            </section>

            <div className="package-editor__grid">
                <fieldset className="package-editor__fieldset">
                    <legend>Hero kartı</legend>
                    <label className="package-editor__label" htmlFor="package-card-title">Kart başlığı</label>
                    <input
                        id="package-card-title"
                        className="package-editor__input"
                        value={draft.cardTitle}
                        onChange={(event) => handleFieldChange("cardTitle", event.target.value)}
                        placeholder="KONUT"
                    />
                    <label className="package-editor__label" htmlFor="package-card-summary">Kart özeti</label>
                    <textarea
                        id="package-card-summary"
                        className="package-editor__textarea"
                        value={draft.cardSummary}
                        onChange={(event) => handleFieldChange("cardSummary", event.target.value)}
                        placeholder="Kart açıklaması"
                    />
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Modal içerik</legend>
                    <label className="package-editor__label" htmlFor="package-slug">Anchor (slug)</label>
                    <input
                        id="package-slug"
                        className="package-editor__input"
                        value={draft.slug}
                        onChange={(event) => handleFieldChange("slug", event.target.value)}
                        placeholder="konut"
                    />
                    <label className="package-editor__label" htmlFor="package-title">Başlık</label>
                    <input
                        id="package-title"
                        className="package-editor__input"
                        value={draft.title}
                        onChange={(event) => handleFieldChange("title", event.target.value)}
                        placeholder="Konut Görselleştirme Paketi"
                    />
                    <div className="package-editor__chips">
                        <span className="package-editor__chip-label">Meta bilgileri</span>
                        {(draft.meta ?? []).map((item, index) => (
                            <div key={`package-meta-${index}`} className="package-editor__chip">
                                <input
                                    className="package-editor__input"
                                    value={item}
                                    onChange={(event) => handleMetaChange(index, event.target.value)}
                                    placeholder="8K render"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeMeta(index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={addMeta}>
                            Meta satırı ekle
                        </button>
                    </div>
                    <div className="package-editor__chips">
                        <span className="package-editor__chip-label">Açıklama paragrafları</span>
                        {(draft.body ?? []).map((item, index) => (
                            <div key={`package-body-${index}`} className="package-editor__chip">
                                <textarea
                                    className="package-editor__textarea"
                                    value={item}
                                    onChange={(event) => handleBodyChange(index, event.target.value)}
                                    placeholder="Detaylı açıklama"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeBody(index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={addBody}>
                            Paragraf ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>CTA</legend>
                    <label className="package-editor__label" htmlFor="package-cta-label">CTA etiketi</label>
                    <input
                        id="package-cta-label"
                        className="package-editor__input"
                        value={draft.ctaLabel}
                        onChange={(event) => handleFieldChange("ctaLabel", event.target.value)}
                        placeholder="Brief gönder"
                    />
                    <label className="package-editor__label" htmlFor="package-cta-url">CTA bağlantısı</label>
                    <input
                        id="package-cta-url"
                        className="package-editor__input"
                        value={draft.ctaUrl}
                        onChange={(event) => handleFieldChange("ctaUrl", event.target.value)}
                        placeholder="mailto:studio@modelerman.com"
                    />
                </fieldset>
            </div>

            <footer className="package-editor__actions">
                <div className="package-editor__left">
                    <button type="button" className="package-editor__button" onClick={onReset} disabled={saving || !hasChanges}>
                        Sıfırla
                    </button>
                    <button type="button" className="package-editor__button" onClick={onDuplicate} disabled={saving}>
                        Kopyala
                    </button>
                </div>
                <div className="package-editor__right">
                    <button type="button" className="package-editor__button" onClick={() => onDelete(draft.id)} disabled={saving}>
                        Sil
                    </button>
                    <button
                        type="button"
                        className="package-editor__button package-editor__button--primary"
                        onClick={onSave}
                        disabled={saving || !hasChanges}
                    >
                        {saving ? "Kaydediliyor..." : "Değişiklikleri kaydet"}
                    </button>
                </div>
            </footer>
        </aside>
    );
}
